module.exports = __webpack_public_path__ + "img/key.86030c1e.svg";